import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const StackSimple: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 506.96c-2.73 0-5.46-.7-7.91-2.1l-255-145.71c-4.97-2.84-8.03-8.12-8.03-13.84s3.06-11 8.03-13.84l255-145.71c4.9-2.8 10.91-2.8 15.81 0l255 145.71c4.97 2.84 8.03 8.12 8.03 13.84s-3.06 11-8.03 13.84l-255 145.71c-2.45 1.4-5.18 2.1-7.91 2.1zm-222.88-161.65 222.88 127.36 222.88-127.36-222.88-127.36z' />
    <path d='m390 598.03c-2.73 0-5.46-.7-7.91-2.1l-255-145.71c-7.64-4.37-10.3-14.1-5.93-21.75 4.37-7.64 14.1-10.3 21.74-5.93l247.09 141.2 247.09-141.2c7.64-4.37 17.38-1.71 21.74 5.93 4.37 7.64 1.71 17.38-5.93 21.75l-255 145.71c-2.45 1.4-5.18 2.1-7.91 2.1z' />
  </IconBase>
));

StackSimple.displayName = 'StackSimple';

export default StackSimple;
